import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Notification } from 'base-ui'

export const AfterSalesImageControlMaxImagesNotification: FC<{
  maxImages: number
}> = ({ maxImages }) => {
  const intl = useIntl()
  const notificationTitle = intl.formatMessage(
    {
      id: 'uploadImage.notification.maxImages.title',
    },
    { maxImages },
  )

  return (
    <Notification
      className="bg-transparent p-0"
      severity="error"
      title={notificationTitle}
      variant="secondary"
    >
      <FormattedMessage id="uploadImage.notification.maxImages.message" />
    </Notification>
  )
}
